<template>
  <div class="identity-picker-container onboarding-block-wrapper">
    <div class="onboarding-block-container">
      <div class="onboarding-block-title">请选择你当前的身份：</div>
      <div class="desc-title">性别</div>
      <div class="gender-list flex">
        <PickerBtn class="flex-1" :active="gender === '男'" @click="handleGender('男')">
          <template #content>
            <i class="iconfont iconnan"></i>
            <span>男生</span>
          </template>
        </PickerBtn>
        <PickerBtn class="flex-1" :active="gender === '女'" @click="handleGender('女')">
          <template #content>
            <i class="iconfont iconnv"></i>
            <span>女生</span>
          </template>
        </PickerBtn>
      </div>
      <div class="desc-title">求职身份</div>
      <div class="flex" style="gap: 20px">
        <PickerBtn
          class="flex-1"
          text="学生"
          :active="identity === 'student'"
          @click="handleIdentity('student')"
        >
        </PickerBtn>
        <PickerBtn
          class="flex-1"
          text="职场人"
          :active="identity === 'already_work'"
          @click="handleIdentity('already_work')"
        >
        </PickerBtn>
      </div>
    </div>
  </div>
</template>
<script>
import PickerBtn from './PickerBtn.vue';
export default {
  name: 'IdentityPicker',
  components: {
    PickerBtn,
  },
  props: {
    gender: {
      type: String,
      default: '',
    },
    identity: {
      type: String,
      default: '',
    },
  },
  data() {
    return {};
  },
  methods: {
    handleGender(gender) {
      this.$emit('confirm', gender, 'gender');
    },
    handleIdentity(identity) {
      this.$emit('confirm', identity, 'status');
    },
  },
};
</script>
<style lang="scss" scoped>
@import '../styles/index.scss';
.identity-picker-container {
  padding-left: 64px;
  .onboarding-block-container {
    width: 580px;
    .onboarding-block-title {
      font-size: 16px;
      color: #fff;
      margin-bottom: 20px;
    }
    .desc-title {
      font-size: 12px;
      color: #9a9ca2;
      margin-bottom: 12px;
    }
    .gender-list {
      gap: 20px;
      margin-bottom: 20px;
      .iconfont {
        font-size: 13px;
        margin-right: 8px;
      }
    }
  }
}
</style>
